"use strict";
var _a, _b, _c;
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpportunityPolicyDocket = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const opportunity_entity_1 = require("./opportunity.entity");
const look_up_entity_1 = require("./look-up.entity");
const policy_docket_document_map_entity_1 = require("./policy-docket-document-map.entity");
let OpportunityPolicyDocket = class OpportunityPolicyDocket {
};
exports.OpportunityPolicyDocket = OpportunityPolicyDocket;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    tslib_1.__metadata("design:type", Number)
], OpportunityPolicyDocket.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "opportunity_id", type: "int", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], OpportunityPolicyDocket.prototype, "opportunityId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "activity_id", type: "int", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], OpportunityPolicyDocket.prototype, "activityId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "opportunity_activity_id", type: "int", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], OpportunityPolicyDocket.prototype, "opportunityActivityId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "status_lid", type: "int", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], OpportunityPolicyDocket.prototype, "statusLid", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "issuance_date", type: "date", nullable: true }),
    tslib_1.__metadata("design:type", typeof (_a = typeof Date !== "undefined" && Date) === "function" ? _a : Object)
], OpportunityPolicyDocket.prototype, "issuanceDate", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "held_cover_note", type: "int", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], OpportunityPolicyDocket.prototype, "heldCoverNote", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "policy_document", type: "int", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], OpportunityPolicyDocket.prototype, "policyDocument", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "policy_docket", type: "int", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], OpportunityPolicyDocket.prototype, "policyDocket", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "endorsement", type: "int", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], OpportunityPolicyDocket.prototype, "endorsement", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "health_claims", type: "int", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], OpportunityPolicyDocket.prototype, "healthClaims", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "non_health_claims", type: "int", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], OpportunityPolicyDocket.prototype, "nonHealthClaims", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "mir", type: "int", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], OpportunityPolicyDocket.prototype, "mir", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "monthly_meeting", type: "int", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], OpportunityPolicyDocket.prototype, "monthlyMeeting", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "quarterly_meeting", type: "int", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], OpportunityPolicyDocket.prototype, "quarterlyMeeting", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "renewal_notice", type: "int", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], OpportunityPolicyDocket.prototype, "renewalNotice", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "data_collection", type: "int", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], OpportunityPolicyDocket.prototype, "dataCollection", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "remarks", type: "varchar", length: 500, nullable: true }),
    tslib_1.__metadata("design:type", String)
], OpportunityPolicyDocket.prototype, "remarks", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "created_by", type: "int", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], OpportunityPolicyDocket.prototype, "createdBy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "updated_by", type: "int", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], OpportunityPolicyDocket.prototype, "updatedBy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.CreateDateColumn)({ name: "created_at", type: "timestamptz" }),
    tslib_1.__metadata("design:type", typeof (_b = typeof Date !== "undefined" && Date) === "function" ? _b : Object)
], OpportunityPolicyDocket.prototype, "createdAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.UpdateDateColumn)({ name: "updated_at", type: "timestamptz" }),
    tslib_1.__metadata("design:type", typeof (_c = typeof Date !== "undefined" && Date) === "function" ? _c : Object)
], OpportunityPolicyDocket.prototype, "updatedAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => opportunity_entity_1.Opportunity, (opportunity) => opportunity.id, {
        onDelete: "SET NULL",
    }),
    (0, typeorm_1.JoinColumn)({ name: "opportunity_id" }),
    tslib_1.__metadata("design:type", Object)
], OpportunityPolicyDocket.prototype, "opportunity", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToOne)(() => look_up_entity_1.LookUp),
    (0, typeorm_1.JoinColumn)({ name: "status_lid", referencedColumnName: "id" }),
    tslib_1.__metadata("design:type", Object)
], OpportunityPolicyDocket.prototype, "status", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToMany)(() => policy_docket_document_map_entity_1.PolicyDocketDocumentMap, (document) => document.policyDocket, {
        cascade: true,
    }),
    tslib_1.__metadata("design:type", Array)
], OpportunityPolicyDocket.prototype, "documents", void 0);
exports.OpportunityPolicyDocket = OpportunityPolicyDocket = tslib_1.__decorate([
    (0, typeorm_1.Entity)("opportunity_policy_docket")
], OpportunityPolicyDocket);
